import axios from "axios";
import { toast } from "react-toastify";
export const GetAllDepreciate = (data) => {
  return {
    type: "get_allDepreciate",
    payload: data,
    loader: false,
  };
};
export function getallDepreciate() {
  return (dispatch) => {
    axios({
      url: `${process.env.REACT_APP_API_URL}Depreciation/Assets`,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllDepreciate(result.data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
